export default {
  id: {
    value: null,
    required: false,
    state: null
  },
  numeroProcesso: {
    value: null,
    required: false,
    state: null
  },
  cnj: {
    value: null,
    required: false,
    state: null
  },
  pessoaId: {
    value: null,
    required: false,
    options: [],
    state: null
  },
  assuntoId: {
    value: null,
    required: false,
    options: [],
    state: null
  },
  objetoAcaoId: {
    value: null,
    required: false,
    options: [],
    state: null
  },
  comarcaId: {
    value: null,
    required: false,
    state: null
  },
  prognosticoId: {
    value: null,
    required: false,
    state: null
  },
  faseId: {
    value: null,
    required: false,
    options: [],
    state: null
  },
  advogadoResponsavel: {
    value: null,
    required: false,
    state: null
  },
  advogadoContrario: {
    value: null,
    required: false,
    state: null
  },
  valorCausa: {
    value: null,
    required: false,
    state: null
  },
  valorCausa2: {
    value: null,
    required: false,
    state: null
  },
  dataDistribuicao: {
    value: null,
    required: false,
    state: null
  },
  ultimoAndamento: {
    value: null,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/ajuizamento/modal/ajuizamentomodal-form.js